// services/Deliverable.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class Member extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "member";
    static pluralName = "members";
    static displayName = "Member";

    constructor() {
        super(`${Member.kind}`,`${Member.singularName}`,`${Member.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.find(id, _query);
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
